import { useTranslation } from 'react-i18next'

import { useDateLimits } from '../../../../../../hooks'
import Button, {
  BUTTON_HEIGHT_24,
  BUTTON_HEIGHT_32,
} from '../../../../../Button'
import { DatePicker } from '../../../../../DateTime'
import { ICON_HEIGHT_16 } from '../../../../../Icon'
import { IntegerInput } from '../../../../../Input'

import {
  QA_NAME_MATCH_EDITOR_CANCEL,
  QA_NAME_MATCH_EDITOR_INPUT,
  QA_NAME_MATCH_EDITOR_SAVE,
} from './ApplicantFitCheckBlockRowEditor.constants'
import {
  getIsMatchEditorDateKind,
  getMatchEditorLimits,
} from './ApplicantFitCheckBlockRowEditor.utils'

import * as styles from './ApplicantFitCheckBlockRowEditor.module.css'

import CheckmarkIcon from '../../../../../../icons/checkmark.svg'
import CloseIcon from '../../../../../../icons/close.svg'

function ApplicantFitCheckBlockRowEditor({
  criterion,
  isSaving,
  value,
  onCancel,
  onChange,
  onSave,
}) {
  const { t } = useTranslation()

  const { maxDate, minDate } = useDateLimits()

  const { max, min } = getMatchEditorLimits(criterion)

  const commonInputProps = {
    autoFocus: true,
    disabled: isSaving,
    height: BUTTON_HEIGHT_32,
    qaName: QA_NAME_MATCH_EDITOR_INPUT,
    value,
    wrapperClassName: styles.input,
    onChange,
  }

  const commonActionProps = {
    disabled: isSaving,
    height: BUTTON_HEIGHT_24,
    isGrey: true,
  }

  return (
    <div className={styles.ApplicantFitCheckBlockRowEditor}>
      {getIsMatchEditorDateKind(criterion) ? (
        <DatePicker
          {...commonInputProps}
          maxValue={maxDate}
          minValue={minDate}
        />
      ) : (
        <IntegerInput {...commonInputProps} max={max} min={min} />
      )}
      <div className={styles.actions}>
        <Button.Text
          {...commonActionProps}
          beforeIconProps={{ Icon: CheckmarkIcon, height: ICON_HEIGHT_16 }}
          qaName={QA_NAME_MATCH_EDITOR_SAVE}
          tooltip={t('RentalPortal.MatchEditorSaveKey')}
          onClick={onSave}
        />
        <Button.Text
          {...commonActionProps}
          beforeIconProps={{ Icon: CloseIcon, height: ICON_HEIGHT_16 }}
          qaName={QA_NAME_MATCH_EDITOR_CANCEL}
          tooltip={t('RentalPortal.MatchEditorCancelKey')}
          onClick={onCancel}
        />
      </div>
    </div>
  )
}

export default ApplicantFitCheckBlockRowEditor
